// extracted by mini-css-extract-plugin
export default {"header":"SidebarHeader_header__bksNq","subheading":"SidebarHeader_subheading__lJvy1","sr-only":"SidebarHeader_sr-only__xdSJz"};